import {components} from "react-select";
import React from "react";

const MenuList = props => {
    return (
        <components.MenuList {...props}>
            {props.children}
        </components.MenuList>
    );
};

export default MenuList;